/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FactorTaxonomyConfiguration } from './factorTaxonomyConfiguration';


/**
 * Template taxonomy configurations by Factor type
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProgramTemplateTaxonomy { 
    /**
     * Template taxonomy set name
     */
    readonly name?: string;
    /**
     * Date template set was published
     */
    readonly publishedDate?: string | null;
    /**
     * Taxonomy configurations for each Factor type
     */
    factorTaxonomyConfigurations?: Array<FactorTaxonomyConfiguration>;

    constructor(item?: Partial<ProgramTemplateTaxonomy>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            name: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.name : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            publishedDate: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.publishedDate : itemOrValue;

                    if (itemOrValue?.publishedDate != null) {
                        if (itemOrValue.publishedDate === '') {
                            itemOrValue.publishedDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.publishedDate = parseInt(itemOrValue.publishedDate.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.publishedDate = parseFloat(itemOrValue.publishedDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            factorTaxonomyConfigurations: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.factorTaxonomyConfigurations : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramTemplateTaxonomy.isValid,
        };
    }

    static isValid(obj: ProgramTemplateTaxonomy): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramTemplateTaxonomy.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.name.isValid(item);
            result = result && validationObject.publishedDate.isValid(item);
            result = result && validationObject.factorTaxonomyConfigurations.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

